module.exports = __webpack_public_path__ + "static/media/loading.69a3e0c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/loading.svg
// module id = 779
// module chunks = 0